import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { syncFullscreenState } from "./State/actions";
import { addFullscreenChangeListener } from "./utilities";
import Stage from "./Stage";
import GameRulesOverlay from "./Components/UserInterface/secondary/Menu/GameRulesOverlay";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const cleanup = addFullscreenChangeListener(() => {
      dispatch(syncFullscreenState());
    });

    return cleanup;
  }, [dispatch]);

  return (
    <>
      <Stage />
      <GameRulesOverlay />
    </>
  );
};

export default App;
